export default __webpack_public_path__ + "static/media/CorrectAnswer2.8272f14e.mp3";